import axios from "axios";
import { Chart } from "devextreme-react";
import {
  ArgumentAxis,
  CommonAxisSettings,
  CommonSeriesSettings,
  Export,
  Label,
  Legend,
  Series,
  Tooltip,
  ValueAxis,
} from "devextreme-react/chart";
import React, { useEffect, useState } from "react";
import { CLINIC_STEP_NAMEList } from "./data";

export default function Distribution(props) {
  const [dataSource, setDataSource] = useState(null);

  const { title, url, argumentField, indication, palette } = props;

  // const CLINIC_STEP_NAMEList = [
  //   "0상",
  //   "1/2상",
  //   "1/2a상",
  //   "1/3상",
  //   "1상",
  //   "1b상",
  //   "2/3상",
  //   "2상",
  //   "2a상",
  //   "2b/3상",
  //   "2b상",
  //   "3/4상",
  //   "3상",
  //   "3a상",
  //   "3b상",
  //   "4상",
  //   "생동",
  //   "연구자 임상시험",
  //   "연장",
  // ];

  useEffect(async () => {
    axios
      .get(
        // `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/SPONSOR/TOP10`
        `${process.env.REACT_APP_BECCO_API_URL}${url}?indication=${indication}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [indication]);

  const customizeTooltip = (arg) => {
    return {
      text: `${arg.seriesName}: ${Number(arg.valueText).toLocaleString()}`,
    };
  };

  const customizeText = (pointInfo) => {
    return `${pointInfo.argumentText}`;
  };

  return (
    <React.Fragment>
      <Chart
        id="sponsorDistributionChart"
        // title={"임상시험 신청자 (Sponsor) 분포 (TOP 10)"}
        title={title}
        dataSource={dataSource}
        rotated={true}
        palette={palette}
      >
        <CommonSeriesSettings
          // argumentField={"APPLY_ENTP_NAME"}
          argumentField={argumentField}
          type="stackedBar"
        />
        {CLINIC_STEP_NAMEList.map((csn, index) => {
          return <Series key={csn} valueField={csn} name={csn} />;
        })}
        <ArgumentAxis inverted={true} />
        <Legend verticalAlignment={"bottom"} horizontalAlignment={"center"} />
        <Export enabled={true} />
        <Tooltip
          enabled={true}
          location={"edge"}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
    </React.Fragment>
  );
}
